import 'whatwg-fetch';
import {history} from '../../router/history';
import {
    setParentPass,
    add_msg
} from '../../actions'
import fetchConfig from '../fetchConfig'
import SystemModal from '../SystemModal/SystemModal'
import fetchExtend from "../fetchExtend";

// 圖片驗證函數
const validateImage = (file) => {
    // 檢查檔案類型
    if (!file.type.match(/^image\/(jpeg|png|gif)$/)) {
        throw new Error('請上傳 JPG、PNG 或 GIF 格式的圖片');
    }

    // 檢查檔案大小（限制為 20MB）
    if (file.size > 20 * 1024 * 1024) {
        throw new Error('圖片大小不能超過 20MB');
    }
    
    return true;
};

export default {
    edit: (dispatch) => {
        SystemModal.showLoadMsg(dispatch)
        fetch(API_SERVER+'/api/v1/parent_passes/0/edit', {
            credentials: 'same-origin',
            method: 'GET',
            headers: new fetchConfig().fetchConfigHeaders()
        }).then(fetchExtend.checkStatus)
            .then(fetchExtend.parseJSON)
            .then((json) => {
                SystemModal.closeMsg(dispatch)
                dispatch(setParentPass(json))
            })
            .catch(function (error) {
                SystemModal.closeMsg(dispatch)
                SystemModal.showLoadErrorMsg(dispatch)
                console.error('Edit error:', error);
            });
    },
    update: (dispatch, payload) => {
        SystemModal.showSaveMsg(dispatch)
        let payloadValue = payload.toJS();
        if (payloadValue.ques_check) {
            SystemModal.closeMsg(dispatch)
            dispatch(add_msg('家長接送證已鎖定，請聯繫註冊組開啟後再修改', 'error'))
            return
        }
        let formData = new FormData();
        
        try {
            // 基本資料處理
            Object.keys(payloadValue).forEach(key => {
                if (key !== 'guardian1_img' && key !== 'guardian2_img') {
                    formData.append(`parent_pass[${key}]`, payloadValue[key]);
                }
            });

            // 圖片處理
            ['guardian1_img', 'guardian2_img'].forEach(imgKey => {
                const imgValue = payloadValue[imgKey];
                if (imgValue && typeof imgValue === 'object' && imgValue.length > 0) {
                    const file = imgValue[0];
                    validateImage(file);
                    // 將檔案轉換為 blob
                    const blob = new Blob([file], { type: file.type });
                    formData.append(`parent_pass[${imgKey}]`, blob, file.name);
                }
            });

            fetch(API_SERVER+'/api/v1/parent_passes/0.json', {
                credentials: 'same-origin',
                method: 'PATCH',
                headers: new fetchConfig().fetchConfigHeaders(),
                body: formData
            }).then(fetchExtend.checkStatus)
                .then(fetchExtend.parseJSON)
                .then((json) => {
                    SystemModal.closeMsg(dispatch);
                    dispatch(add_msg('儲存完成'));
                    history.push('/devise_dashboard');
                })
                .catch(function (error) {
                    throw error;
                });
        } catch (error) {
            console.error('Update error:', error);
            SystemModal.closeMsg(dispatch);
            dispatch(add_msg(error.message || '儲存失敗，請確認圖片格式正確且大小適中'));
            SystemModal.showSaveErrorMsg(dispatch);
        }
    },
    updateImg: (dispatch, imgName, payload) => {
        SystemModal.showSaveMsg(dispatch);
        
        try {
            if (!payload || !payload.length) {
                throw new Error('請選擇要上傳的圖片');
            }

            const file = payload[0];
            validateImage(file);

            let formData = new FormData();
            // 將檔案轉換為 blob
            const blob = new Blob([file], { type: file.type });
            formData.append(`parent_pass[${imgName}]`, blob, file.name);

            console.log(`準備上傳 ${imgName} 圖片到 ${API_SERVER}`);

            fetch(API_SERVER+'/api/v1/parent_passes/0.json', {
                credentials: 'same-origin',
                method: 'PATCH',
                headers: new fetchConfig().fetchConfigHeaders(),
                body: formData
            }).then(fetchExtend.checkStatus)
                .then(fetchExtend.parseJSON)
                .then((json) => {
                    SystemModal.closeMsg(dispatch);
                    dispatch(add_msg('圖片上傳成功'));
                    console.log(`${imgName} 上傳成功，返回數據:`, json);
                    
                    // 檢查返回的JSON中是否包含圖片路徑
                    if (json && json[imgName]) {
                        console.log(`伺服器返回的 ${imgName} 路徑:`, json[imgName]);
                        console.log(`完整URL將為: ${API_SERVER}${json[imgName].startsWith('/') ? '' : '/'}${json[imgName]}`);
                    }
                    
                    // 重新獲取最新的資料
                    return fetch(API_SERVER+'/api/v1/parent_passes/0/edit', {
                        credentials: 'same-origin',
                        method: 'GET',
                        headers: new fetchConfig().fetchConfigHeaders()
                    });
                })
                .then(fetchExtend.checkStatus)
                .then(fetchExtend.parseJSON)
                .then((json) => {
                    console.log('獲取到的最新數據:', json);
                    dispatch(setParentPass(json));
                })
                .catch(function (error) {
                    throw error;
                });
        } catch (error) {
            console.error('Update image error:', error);
            SystemModal.closeMsg(dispatch);
            dispatch(add_msg(error.message || '圖片上傳失敗，請確認圖片格式正確且大小適中'));
            SystemModal.showSaveErrorMsg(dispatch);
        }
    }
}



// WEBPACK FOOTER //
// ./src/dashboards_redux/utils/ParentPass/ParentPass.jsx